import {Observable, of} from 'rxjs';
import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import {LoadCodes} from '../actions/codes.actions';
import {catchError, filter, switchMapTo, take, tap} from 'rxjs/operators';

@Injectable()
export class CodesGuard implements CanActivate {

  constructor(private store: Store<fromRoot.State>) {
  }

  public canActivate(): Observable<boolean> {
    return this.checkCodes()
      .pipe(
        switchMapTo(of(true)),
        catchError(() => of(false))
      );
  }

  checkCodes(): Observable<boolean> {
    return this.store.pipe(
      select(fromRoot.selectCodesLoaded),
      tap(isLoaded => {
        if (!isLoaded) {
          this.store.dispatch(LoadCodes());
        }
      }),
      filter(isLoaded => isLoaded),
      take(1)
    );
  }
}
